/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Distribution_TitleInputs */

const en_us2_progress_report_distribution_title = /** @type {(inputs: Progress_Report_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscle distribution`)
};

const pt_br2_progress_report_distribution_title = /** @type {(inputs: Progress_Report_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribuição muscular`)
};

const es_419_progress_report_distribution_title = /** @type {(inputs: Progress_Report_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribución muscular`)
};

const pt_pt2_progress_report_distribution_title = /** @type {(inputs: Progress_Report_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribuição muscular`)
};

const fr_fr2_progress_report_distribution_title = /** @type {(inputs: Progress_Report_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répartition musculaire`)
};

const de_de2_progress_report_distribution_title = /** @type {(inputs: Progress_Report_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskelverteilung`)
};

const it_it2_progress_report_distribution_title = /** @type {(inputs: Progress_Report_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribuzione muscolare`)
};

/**
* | output |
* | --- |
* | "Muscle distribution" |
*
* @param {Progress_Report_Distribution_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_distribution_title = /** @type {((inputs?: Progress_Report_Distribution_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Distribution_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_distribution_title(inputs)
	if (locale === "es-419") return es_419_progress_report_distribution_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_distribution_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_distribution_title(inputs)
	if (locale === "de-DE") return de_de2_progress_report_distribution_title(inputs)
	if (locale === "it-IT") return it_it2_progress_report_distribution_title(inputs)
	return en_us2_progress_report_distribution_title(inputs)
});
export { progress_report_distribution_title as "progress-report.distribution_title" }